import { createSlice } from '@reduxjs/toolkit'

export const task = createSlice({
	name: 'task',
	initialState: {
		status: '',
	},
	reducers: {
		setStatus: (state, action) => {
			state.status = action.payload
		},
	},
})
